import { getRoute } from 'Config';

// Routes
export const MUTUAL_FRIENDS_SETTINGS_ROUTE = getRoute('mutualFriendsSettings');
